import { render } from "./MyNumbersSection.vue?vue&type=template&id=40b8f3ea&scoped=true"
import script from "./MyNumbersSection.vue?vue&type=script&lang=js"
export * from "./MyNumbersSection.vue?vue&type=script&lang=js"

import "./MyNumbersSection.vue?vue&type=style&index=0&id=40b8f3ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b8f3ea"]])

export default __exports__